import orderStorage from "./orderStorage";
const AUTH_KEY = "production-scheduler-auth-info";
const USER_KEY = "production-scheduler-user-info";
const userStorage = {
  getAuthInfo() {
    return orderStorage.getJson(AUTH_KEY) || {};
  },
  saveAuthInfo(authInfo: any) {
    orderStorage.setJson(AUTH_KEY, {
      ...authInfo,
    });
  },
  updateAuthToken(authInfo: any) {
    let previousAuthInfo = this.getAuthInfo();
    let updatedAuthInfo = { ...previousAuthInfo, ...authInfo };
    orderStorage.setJson(AUTH_KEY, {
      ...updatedAuthInfo,
    });
  },
  getUserInfo() {
    return orderStorage.getJson(USER_KEY) || {};
  },
  saveUserInfo(userInfo: any) {
    orderStorage.setJson(USER_KEY, { ...userInfo });
  },
  revoveAllInfo() {
    orderStorage.clear(AUTH_KEY);
    orderStorage.clear(USER_KEY);
  },
};

export default userStorage;
